module.exports = __webpack_public_path__ + "static/media/emc.522e0622.svg";